<template>
  <div class="student-double-teacher-page">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/welcome' }">主页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/studentList'}">在读学员</el-breadcrumb-item>
      <el-breadcrumb-item>双师学习记录</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
      <div slot="header" class="card-header">
        <span>学生：{{realname}} - 双师训练/错题/答题记录</span>
        <el-button icon="el-icon-back" @click="back" size="mini">返回</el-button>
      </div>

      <!-- 查询条件 -->
      <el-form :model="queryParam" inline>
        <el-form-item label="训练类型">
          <el-select v-model="queryParam.challengeType" clearable placeholder="全部">
            <el-option label="智能训练" value="1"></el-option>
            <el-option label="任务挑战" value="2"></el-option>
            <el-option label="强基训练" value="3"></el-option>
            <el-option label="错题记录" value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学科">
          <el-select v-model="queryParam.subjectId" clearable placeholder="全部">
            <el-option
              v-for="item in subjectList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年级">
          <el-select v-model="queryParam.gradeId" clearable placeholder="全部">
            <el-option
              v-for="item in gradeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="loadData">查询</el-button>
          <el-button @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 表格：完全按你的教务风格 -->
      <el-table :data="dataList" stripe border :loading="loading" max-height="600">
        <el-table-column label="序号" type="index" width="60"></el-table-column>
        <el-table-column label="题型" width="100">
          <template slot-scope="scope">
            {{ scope.row.examType == 1 ? '单选' :
            scope.row.examType == 2 ? '多选' :
            scope.row.examType == 3 ? '填空' :
            scope.row.examType == 4 ? '判断' : '' }}
          </template>
        </el-table-column>
        <el-table-column label="题目" min-width="280">
          <template slot-scope="scope">
            <div v-html="scope.row.content"></div>
          </template>
        </el-table-column>
        <el-table-column label="结果" width="80">
          <template slot-scope="scope">
            <span :style="{color:scope.row.userAnswerFlag==1?'green':'red'}">
              {{ scope.row.userAnswerFlag == 1 ? '正确' : '错误' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="学科/年级" width="160">
          <template slot-scope="scope">
            {{ scope.row.subjectId_dictText }} | {{ scope.row.gradeId_dictText }}
          </template>
        </el-table-column>
        <el-table-column label="训练时间" width="180" prop="challengeTime"></el-table-column>
      </el-table>

      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-size="pageSize"
        :total="total"
        background
        style="text-align:right;margin-top:20px">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        phone: '',
        realname: '',
        queryParam: {
          challengeType: '1',
          subjectId: '',
          gradeId: ''
        },
        subjectList: [
          { id: '1273192918914994177', name: '智能数学' },
          { id: '1273275645626441729', name: '智能语文' },
          { id: '1273275718506668033', name: '智能英语' },
          { id: '1273275829026578434', name: '暑期数学' },
          { id: '1273275894373834753', name: '暑期语文' },
          { id: '1273275970143936514', name: '暑期英语' },
          { id: '1326324137453625345', name: '智能科学' },
          { id: '1419710664753164289', name: '强基数学' },
          { id: '1712821416454488065', name: '智能化学' },
          { id: '1767774338015256578', name: '智能物理' },
          { id: '1807675816020164610', name: '智能生物' },
          { id: '1922850541922295809', name: '强基科学' },
          { id: '1981234561206652929', name: '智能政治' },
          { id: '1997109630638174210', name: '智能历史' },
          { id: '1997893625739161602', name: '智能地理' }
        ],
        gradeList: [{id: 2,name: '二年级'},
          {id: 3,name: '三年级'},
          {id: 4,name: '四年级'},
          {id: 5,name: '五年级'},
          {id: 6,name: '六年级'},
          {id: 7,name: '七年级'},
          {id: 8,name: '八年级'},
          {id: 9,name: '九年级'},
          {id: 10,name: '高一'},
          {id: 11,name: '高二'},
          {id: 12,name: '高三'}
        ],
        loading: false,
        dataList: [],
        pageNo: 1,
        pageSize: 10,
        total: 0
      }
    },
    created() {
      this.phone = this.$route.query.phone
      this.realname = this.$route.query.realname
      this.queryParam.gradeId = this.$route.query.grade
      this.loadData()
    },
    methods: {
      async loadData() {
        this.loading = true
        try {
          let params = {
            phone: this.phone,
            gradeId: this.queryParam.gradeId,
            challengeType: this.queryParam.challengeType,
            subjectId: this.queryParam.subjectId,
            pageNo: this.pageNo,
            pageSize: this.pageSize
          }
          const { data: res } = await this.$http.post('/ea/student/student/vipssStudentRecordList', params)
          if (res.code === 200) {
            this.dataList = res.result.records
            this.total = res.result.total
          }
        } finally {
          this.loading = false
        }
      },
      resetQuery() {
        this.queryParam.challengeType = ''
        this.queryParam.subjectId = ''
        this.pageNo = 1
        this.loadData()
      },
      handleCurrentChange(page) {
        this.pageNo = page
        this.loadData()
      },
      back() {
        this.$router.go(-1)
      }
    }
  }
</script>

<style lang="less" scoped>
  .student-double-teacher-page {
    padding: 10px;
  }
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 500;
    font-size: 15px;
  }
</style>
